import cn from 'classnames'
import React, { ComponentProps } from 'react'

type PieChartIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function PieChartIcon(props: PieChartIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('PieChartIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_22211_14235)">
        <path
          d="M13.9999 7.99995C14.3679 7.99995 14.6699 7.70061 14.6333 7.33461C14.4796 5.80406 13.8013 4.37375 12.7135 3.28616C11.6257 2.19857 10.1952 1.52064 8.6646 1.36728C8.29793 1.33061 7.99927 1.63261 7.99927 2.00061V7.33395C7.99927 7.51076 8.06951 7.68033 8.19453 7.80535C8.31955 7.93038 8.48912 8.00061 8.66593 8.00061L13.9999 7.99995Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1399 10.5934C13.7158 11.5964 13.0525 12.4802 12.2079 13.1676C11.3633 13.855 10.3631 14.325 9.2949 14.5366C8.22668 14.7481 7.12289 14.6948 6.08004 14.3813C5.03719 14.0677 4.08703 13.5034 3.31262 12.7378C2.53822 11.9722 1.96315 11.0286 1.6377 9.98935C1.31225 8.95015 1.24632 7.84704 1.44568 6.77647C1.64503 5.70591 2.10361 4.70047 2.78131 3.84807C3.45901 2.99567 4.3352 2.32226 5.33328 1.88672"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22211_14235">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
